import WithRender from "../../templates/ui/selectRangeOption.html";
import { mapGetters, mapActions } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getIsCimpressProduct", "getActiveProductPageOptions"]),
    getType: function () {
      return this.getIsCimpressProduct && this.isRange
        ? "appRangeAttribute"
        : "appSelectOption";
    },
    isRange: function () {
      return this.getActiveProductPageOptions[this.code].isRange;
    },
    getPropsData: function () {
      return this.getIsCimpressProduct && this.isRange
        ? this.getActiveProductPageOptions[this.code]
        : this.propsData;
    },
    code: function () {
      return this.propsData.code;
    }
  },
  methods: {
    ...mapActions(["setPageOption"])
  },
  props: ["propsData", "optionType", "selectId"]
});
